import * as numeral from 'numeral';

export class PercentageFormatValueConverter {
	toView(value) {
		if (value) return `${value}%`;
		return '';
    }
}